import { render, staticRenderFns } from "./BillReceivebleDashboard.vue?vue&type=template&id=e71c7ce8"
import script from "./BillReceivebleDashboard.vue?vue&type=script&lang=js"
export * from "./BillReceivebleDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports